import { setUser } from "@sentry/react"
import { Button, Typography } from "@suraasa/placebo-ui"
import api from "api"
import { User } from "api/resources/auth/types"
import LoadingOverlay from "components/shared/LoadingOverlay"
import { useEffect, useState } from "react"
import { Outlet, useSearchParams } from "react-router-dom"
import { AuthManager } from "utils/AuthManager"
import { USER_TYPE } from "utils/constants"

const SSO = () => {
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState("")

  const [searchParams, setSearchParams] = useSearchParams()
  const [userInfo, setUserInfo] = useState<User | null>(
    AuthManager.getAuthInfo()?.user || null
  )
  useEffect(() => {
    if (!userInfo) return

    setUser({ id: userInfo.uuid, email: userInfo.email })

    setLoading(false)
  }, [userInfo])

  const getPlatformToken = async (code: string) => {
    setLoading(true)
    try {
      const res = await api.auth.generatePlatformToken({
        data: {
          code,
          platform: USER_TYPE,
        },
      })
      AuthManager.saveAuthInfo(res)
      setUserInfo(res.user)
      setLoading(false)

      searchParams.delete("code")
      setSearchParams(searchParams, { replace: true })
    } catch (error) {
      setLoading(false)
      setError("Something went wrong, please try again!")
    }
  }

  const getCode = () => {
    AuthManager.redirectToLogin()
  }

  useEffect(() => {
    const code = searchParams.get("code")
    if (code) {
      getPlatformToken(code)
      return
    }

    if (AuthManager.getAuthInfo()) {
      setLoading(false)
      return
    }

    getCode()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (loading) return <LoadingOverlay showLogo />

  if (error)
    return (
      <div
        className={
          "flex h-screen flex-col items-center justify-center [&_#logo]:translate-x-5"
        }
      >
        <div className="mb-1">
          <Typography variant="title3">{error}</Typography>
        </div>
        <Button onClick={getCode}>Click here to try again</Button>
      </div>
    )

  return <Outlet />
}

export default SSO
